import React from "react";
import "./TagContent.scss"
const TagContent = ({ text, isList = false }) => {
    return (
        <div className="TagContent">
            {isList && <div className="list-point" />}  {text}
        </div>
    )
}
export default TagContent